import Store from '~/store'
import UsersAPI from 'api/UsersAPI'
import AuthService from 'services/AuthService'

const ReferralService = {
    fetchReferralsCountByStatus(params) {
        return UsersAPI.getReferralsCountByStatus(params)
    },

    fetchPendingReferralActions() {
        if (!AuthService.isLoggedIn() || AuthService.isUserTemporaryPhysician() || AuthService.isUserPracticeDemo()) {
            return Promise.resolve()
        }

        const params = AuthService.isPracticeAncillary()
            ? { practiceId: AuthService.getPractice().id }
            : { userId: AuthService.getUser().id }

        return UsersAPI.getPendingReferralActions(params).then((res) => {
            Store.commit('auth/setPendingReferralAction', res)
            return res
        })
    },

    /** Passthrough for API promise chains: refreshes badges in the background, returns the response untouched. */
    refreshPendingReferralActions(res) {
        ReferralService.fetchPendingReferralActions().catch(() => {})
        return res
    },
}

export default ReferralService
